let open = document.querySelectorAll('[data-popup-open]');

[].forEach.call(open, (el) => {
  el.addEventListener('click', (event) => {
    let focusInput = el.getAttribute('data-popup-focusinput');
    document.querySelector('#'+el.getAttribute('data-popup-open')).classList.add('is-active');

    if (focusInput) {
      document.querySelector(`input[name="${focusInput}"]`).focus();
    }
  });
});


let close = document.querySelectorAll('.modal-close');

[].forEach.call(close, (el) => {
  el.addEventListener('click', (event) => {
    el.closest('.modal').classList.remove('is-active');
  });
});


let toggle = document.querySelectorAll('[data-popup-toggle]');

[].forEach.call(toggle, (el) => {
  el.addEventListener('click', (event) => {
    let className = el.getAttribute('data-popup-class');
    if (className) {
      document.querySelector('#'+el.getAttribute('data-popup-toggle')).classList.toggle(className);
    } else {
      document.querySelector('#'+el.getAttribute('data-popup-toggle')).classList.toggle('is-active');
    }
  });
});



// WEBPACK FOOTER //
// ./resources/assets/website/scripts/popup.js